import { render, staticRenderFns } from "./EditSound.vue?vue&type=template&id=7d0ff8a7&"
import script from "./EditSound.vue?vue&type=script&lang=js&"
export * from "./EditSound.vue?vue&type=script&lang=js&"
import style0 from "./EditSound.vue?vue&type=style&index=0&id=7d0ff8a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports